import React, { useState } from 'react';
import { Alert, DocumentForm } from '../shared';
import { Company, User } from '../../models';
import { roles } from '../../static';
import { UserFormFields } from '../shared/Forms/GeneralUserFormFields';
import { AddressForm } from '../shared/Forms/AddressForm';
import { CompanyFormFields } from '../shared/Forms/CompanyFormFields';
import { companyStatus } from '../../static/companyStatus';
import SearchCompany from '../shared/Forms/CompanyFormFields/SearchCompany';
import FormButtons from '../shared/Forms/FormButtons';
import { BenefitForm } from '../benefit';
import { useCreateAndUpdateCompany } from '../../hooks/useCreateAndUpdateCompany';

interface CompanyFormProps {
  companyInfo?: User;
}

function CompanyForm({ companyInfo }: CompanyFormProps) {
  const {
    benefit,
    setBenefit,
    disabled,
    companyReadOnly,
    setCompanyReadOnly,
    addressReadOnly,
    setAddressReadOnly,
    documents,
    setDocuments,
    userState,
    userDispatch,
    companyState,
    companyDispatch,
    addressState,
    addressDispatch,
    // Functions
    onSubmit,
    changeCompanyActive,
    changeCompanyStatus,
  } = useCreateAndUpdateCompany({ companyInfo });

  return (
    <form
      method="POST"
      onSubmit={onSubmit}
      className="flex flex-col w-full space-y-10"
    >
      <Alert
        title="Debe aprobar el nuevo aliado"
        text="Para poder realizar acciones con este aliado, debe aprobarlo primero."
        show={
          (companyInfo?.company as Company)?.status === companyStatus.pending
        }
      />
      <Alert
        title="Este aliado ha sido rechazado"
        text="Este aliado ha sido rechazado, por tanto no podrá realizar acciones en la plataforma."
        show={
          (companyInfo?.company as Company)?.status === companyStatus.rejected
        }
      />
      {!companyInfo ? (
        <SearchCompany
          header={{
            title: '¿Tu compañia ya esta registrada en Meit?',
          }}
          companyDispatch={companyDispatch}
          addressDispatch={addressDispatch}
          setCompanyReadOnly={setCompanyReadOnly}
          setAddressReadOnly={setAddressReadOnly}
        />
      ) : null}
      <CompanyFormFields
        dispatch={companyDispatch}
        state={companyState}
        userType={roles.company}
        header={{
          title: 'Información de la compañia',
          href: '/app/companies',
          backBtnText: 'Lista de compañias',
        }}
        readOnly={companyReadOnly}
      />
      <UserFormFields
        dispatch={userDispatch}
        state={userState}
        userType={roles.company}
        header={{
          title: 'Información del usuario',
        }}
        requiredUserDni={false}
      />
      <AddressForm
        dispatch={addressDispatch}
        state={addressState}
        readOnly={addressReadOnly}
        header={{
          title: 'Dirreción de la compañia',
        }}
      />
      <BenefitForm benefit={benefit} setBenefit={setBenefit} />
      <DocumentForm
        documents={documents}
        updateURLs={setDocuments}
        maximumAmount={1}
      />
      <FormButtons
        type={companyInfo ? 'update' : 'create'}
        toggleActive={changeCompanyActive}
        toggleStatus={changeCompanyStatus}
        active={companyInfo?.active}
        status={(companyInfo?.company as Company)?.status}
        disabled={disabled}
        onSubmit={onSubmit}
      />
    </form>
  );
}

export default CompanyForm;
